import $ from "jquery";
import TweenMax from "gsap/TweenMax";
import AbstractPage from "./AbstractPage";
import { isSlickWrapInitialized } from "../util/util";
class Event extends AbstractPage {
  constructor(options) {
    super(options);
    // 클래스 케어
    const _ = this;

    // _.option
    // _.model

    _._$contents = $(".section-contents", _.$wrap);
    _._$title = $("h2", _._$contents);
    _._$subCopy = $(".subcopy", _._$contents);
    _._$subDate = $(".event-milestone", _._$contents);
    _._$slickWrap = $(".event-list", _._$contents);
  }

  init(obj = null) {
    super.init(obj);

    const _ = this;

    _.setSlick(_._$slickWrap);
    _._reset();

    return _;
  }

  _startAnimation() {
    const _ = this;

    // if (!_.isAnimated) {
    TweenMax.killTweensOf([
      _._$contents,
      _._$title,
      _._$subCopy,
      _._$subDate,
      _._$slickWrap
    ]);

    TweenMax.fromTo(
      _._$contents,
      0.8,
      {
        autoAlpha: 0
      },
      {
        autoAlpha: 1,
        ease: Expo.easeInOut
      }
    );

    TweenMax.fromTo(
      _._$title,
      1.5,
      {
        autoAlpha: 0
      },
      {
        autoAlpha: 1,
        ease: Cubic.easeInOut
      }
    );

    TweenMax.fromTo(
      _._$subCopy,
      1.5,
      {
        autoAlpha: 0
      },
      {
        delay: 0.25,
        autoAlpha: 1,
        ease: Cubic.easeInOut
      }
    );

    TweenMax.fromTo(
      _._$subDate,
      1.5,
      {
        autoAlpha: 0
      },
      {
        delay: 0.45,
        autoAlpha: 1,
        ease: Cubic.easeInOut
      }
    );

    TweenMax.fromTo(
      _._$slickWrap,
      1.5,
      {
        autoAlpha: 0
      },
      {
        delay: 0.55,
        autoAlpha: 1,
        ease: Cubic.easeInOut
      }
    );
    
    // }
    // _.isAnimated = true;

    return _;
  }

  _reset() {
    const _ = this;

    // if (_.isAnimated) return;

    TweenMax.killTweensOf([
      _._$contents,
      _._$title,
      _._$subCopy,
      _._$subDate,
      _._$slickWrap
    ]);

    TweenMax.set(_._$contents, {
      autoAlpha: 0
    });
    TweenMax.set(_._$title, {
      autoAlpha: 0
    });
    TweenMax.set(_._$subCopy, {
      autoAlpha: 0
    });
    TweenMax.set(_._$subDate, {
      autoAlpha: 0
    });
    TweenMax.set(_._$slickWrap, {
      autoAlpha: 0
    });

    return _;
  }

  recalculateSlickWraps() {
    const _ = this,
      isSlickInitialized = isSlickWrapInitialized(_._$slickWrap);

    if (isSlickInitialized) {
      _._$slickWrap.slick("setPosition");
      _._$slickWrap.slick("resize");
    }
  }

  setSlick($slickWrap) {
    if (!$slickWrap || $slickWrap.length <= 0) return;

    $slickWrap.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      autoplay: false,
      dots: true,
      useCSS: true,
      useTransform: false,
      cssEase: "ease-out"
    });

    // $slickWrap.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    //   if (currentSlide === nextSlide) return;
    //   let eventName = $(window).width() < 960 && '191029_slide_eclipse_mobile' || '191029_slide_eclipse_tablet'
    //   // GTM
    //   window.dataLayer && window.dataLayer.push({'event': eventName, '191029_slide_eclipse_count':nextSlide});
    // });
  }

  enter(obj = null) {
    const _ = this;

    _.recalculateSlickWraps();
    _._startAnimation();

    return _;
  }

  exit(obj = null) {
    const _ = this;

    _._reset();

    return _;
  }

  resize(evt = null) {
    const _ = this;

    return _;
  }

  destroy(obj = null) {
    super.destroy(obj);

    const _ = this;

    return _;
  }
}

export default Event;
